export const PRODUCTION_ENV = import.meta.env.VITE_ENV === "production";

export interface AppConfig {
  SUPABASE_URL: string;
  SUPABASE_PUBLISHABLE_KEY: string;
  DOMAIN_NAME: string;
  STORE_DOMAIN_NAME: string;
  SERVELESS_API_URL: string;
  DASHBOARD_URL: string;
  PAYSTACK_PUBLIC_KEY: string;
  POSTHOG_KEY: string;
  POSTHOG_HOST: string;
  JBA_VIDEO_URL: string;
  FLUTTERWAVE_PUBLIC_KEY: string;
  JBA_PAYMENT_AMOUNT: string | number;
  JBA_PAYMENT_CURRENCY: string;
  JBA_PAYMENT_TITLE: string;
  JBA_PAYMENT_DESCRIPTION: string;
  JBA_PAYMENT_OPTIONS: string;
  JBA_FULFILLMENT_ENDPOINT: string;
  JBA_PRODUCT_CODE: string;
  FB_PIXEL_GENERAL: string;
  FB_PIXEL_JBA: string;
}

const sharedJbaConfig = {
  JBA_VIDEO_URL:
    "https://jellosite-backend-prod.s3.eu-central-1.amazonaws.com/Finished+-+Starter-1.m4v",
  FLUTTERWAVE_PUBLIC_KEY: "",
  JBA_PAYMENT_AMOUNT: 59000,
  JBA_PAYMENT_CURRENCY: "NGN",
  JBA_PAYMENT_TITLE: "JBA Launch Access",
  JBA_PAYMENT_DESCRIPTION:
    "JBA launch bundle with onboarding and community access.",
  JBA_PAYMENT_OPTIONS: "card,bank_transfer",
  JBA_FULFILLMENT_ENDPOINT: "/jba/payment/fulfill",
  JBA_PRODUCT_CODE: "jba",
} satisfies Pick<
  AppConfig,
  | "JBA_VIDEO_URL"
  | "FLUTTERWAVE_PUBLIC_KEY"
  | "JBA_PAYMENT_AMOUNT"
  | "JBA_PAYMENT_CURRENCY"
  | "JBA_PAYMENT_TITLE"
  | "JBA_PAYMENT_DESCRIPTION"
  | "JBA_PAYMENT_OPTIONS"
  | "JBA_FULFILLMENT_ENDPOINT"
  | "JBA_PRODUCT_CODE"
>;

const testConfig: AppConfig = {
  SUPABASE_URL: "https://zwzbdduyhutxldoyleue.supabase.co",
  SUPABASE_PUBLISHABLE_KEY: "sb_publishable_WHv3yh-VVQsiTKSFRHUaCw_tjsqwhyp",
  DOMAIN_NAME: "staging.jellosite.com",
  STORE_DOMAIN_NAME: "jellostoretest.com",
  SERVELESS_API_URL:
    "https://d3xlamgu3b.execute-api.eu-central-1.amazonaws.com",
  DASHBOARD_URL: "https://testdashboard.jellosite.com",
  PAYSTACK_PUBLIC_KEY: "pk_test_6e45d8037dad5f4c2bd3ff345dbc2a385fafaf58",
  POSTHOG_KEY: "",
  POSTHOG_HOST: "https://us.i.posthog.com",
  FB_PIXEL_GENERAL: "1250794329327603",
  FB_PIXEL_JBA: "2008762646389456",
  ...sharedJbaConfig,
};

const prodConfig: AppConfig = {
  SUPABASE_URL: "https://rphgmppksexxfhkqmxhs.supabase.co",
  SUPABASE_PUBLISHABLE_KEY: "sb_publishable_SbwyjHWbOYpXAFCWhO05aw_a1HG24SJ",
  DOMAIN_NAME: "jellosite.com",
  DASHBOARD_URL: "https://dashboard.jellosite.com",
  STORE_DOMAIN_NAME: "jellosite.store",
  SERVELESS_API_URL:
    "https://hfls5rr0tf.execute-api.eu-central-1.amazonaws.com",
  PAYSTACK_PUBLIC_KEY: "pk_live_585a3cf72bef871562d3249a03a732b5aa732b23",
  POSTHOG_KEY: "phc_8xXESHmuKgK8582u8BQiFKzBWCnvShDNAS6oyztWh73",
  POSTHOG_HOST: "https://us.i.posthog.com",
  FB_PIXEL_GENERAL: "1250794329327603",
  FB_PIXEL_JBA: "2008762646389456",
  ...sharedJbaConfig,
};

export const config = PRODUCTION_ENV ? prodConfig : testConfig;
